<template>
  <div class="emojiKeyboardMain" :class="{
    emojiKeyboardMainExpanded: $store.state.display.emojiKeyboard.isShown,
    emojiKeyboardMainCollapsed: !$store.state.display.emojiKeyboard.isShown
  }"
  >
    <div class="tabsRow" v-if="emojiList.length > 0">
      <a class="tab" :class="{ tabSelected: index === selectedTabIndex }" v-for="(mainGroup, index) in emojiList"
         :key="index" @click="tabClicked(index)"
      >{{ mainGroup.groupName }}</a>
    </div>
    <div class="tabContentContainer" v-if="emojiList.length > 0">
      <div v-for="(mainGroup, index) in emojiList" :key="index">
        <div class="groupTitle" :id="'emojiGroupTitle' + index">
          {{ mainGroup.groupName }}
        </div>

        <div class="emojiContainer">
          <div class="emoji" v-for="(emoji, emojiIndex) in mainGroup.emojis" :key="emojiIndex"
               @click="insertEmoji(emoji.char)"
          >
            {{ emoji.char }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventbus.js'
export default {
  data () {
    return {
      emojiList: [],
      selectedTabIndex: 0
    }
  },

  methods: {
    insertEmoji (element) {
      EventBus.$emit('insertEmoji', element)
    },

    tabClicked (index) {
      this.selectedTabIndex = index
      var el = document.getElementById('emojiGroupTitle' + index)
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  },

  mounted () {
    this.emojiList = require('@/assets/json/emojilist.json')
  }
}

</script>

<style scoped>
  .emojiKeyboardMain {
    height: 0px;
    background-color: rgb(60, 255, 0);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-shrink: 0;
    overflow: hidden;
  }

  .tabsRow {
    background-color: rgb(231, 231, 231);
    height: 50px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    align-content: stretch;
    font-size: 14px;
  }

  .tab {
    line-height: 50px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: rgb(241, 241, 241);
    text-align: center;
    cursor: pointer;
    margin-right: 0px;
    flex-grow: 1;
    white-space: nowrap;
  }

  .tabSelected {
    border-bottom: 4px solid rgb(135, 201, 255);
  }

  .tabContentContainer {
    background-color: white;
    flex-grow: 0;
    overflow: scroll;
    overflow-x: hidden;
    background-color: white;
    margin: 0px;
  }

  .emojiKeyboardMainExpanded {
    height: 410px;
    transition: height 0.3s;
  }

  .emojiKeyboardMainCollapsed {
    height: 0px;
    transition: height 0.3s;
  }

  .emojiContainer {
    display: flex;
    flex-wrap: wrap;
  }

  .emoji {
    font-size: 35px;
    padding: 5px;
    cursor: pointer;
  }

  .groupTitle {
    padding: 10px;
    color: gray;
    font-size: 12px;
    text-transform: uppercase;
  }

</style>
